/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are boxing rounds 3 minutes long?`)
};

const es_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué los rounds de boxeo duran 3 minutos?`)
};

const de_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum dauern Boxrunden 3 Minuten?`)
};

const nl_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom duren boksrondes 3 minuten?`)
};

const fr_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les rounds de boxe durent-ils 3 minutes ?`)
};

const it_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché i round di boxe durano 3 minuti?`)
};

const pt_br2_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os rounds de boxe duram 3 minutos?`)
};

const pt_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que os assaltos de boxe duram 3 minutos?`)
};

const ja_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜボクシングのラウンドは3分なのですか？`)
};

const zh_timer_u3m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么拳击回合是3分钟？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u3m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u3m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u3m_faq4_q", locale)
	if (locale === "en") return en_timer_u3m_faq4_q(inputs)
	if (locale === "es") return es_timer_u3m_faq4_q(inputs)
	if (locale === "de") return de_timer_u3m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u3m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u3m_faq4_q(inputs)
	if (locale === "it") return it_timer_u3m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u3m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u3m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u3m_faq4_q(inputs)
	return zh_timer_u3m_faq4_q(inputs)
};